import React, { useState, useEffect } from "react"
import {
  CardBody,
  Container,
  Row,
  Col,
  Card,
  Button,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Table,
  Label,
  Modal,
  Form,
} from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import logo from "../../assets/images/onesquar.png"
import { toast } from "react-toastify"
import { useHistory } from "react-router-dom"
import ReactPaginate from "react-paginate"
import classnames from "classnames"
import { URLS } from "../../Url"
import axios from "axios"
import { saveAs } from "file-saver"

function State() {
  const [forms, setforms] = useState([])

  const [activeTab1, setactiveTab1] = useState("5")

  const toggle1 = tab => {
    if (activeTab1 !== tab) {
      setactiveTab1(tab)
    }
  }

  const history = useHistory()

  const [PendingListing, setPendingListing] = useState([])

  var gets = localStorage.getItem("authUser")
  var data = JSON.parse(gets)
  var datas = data.token

  const [listPerPage] = useState(5)
  const [pageNumber, setPageNumber] = useState(0)

  const pagesVisited = pageNumber * listPerPage
  const lists = PendingListing.slice(pagesVisited, pagesVisited + listPerPage)
  const pageCount = Math.ceil(PendingListing.length / listPerPage)
  const changePage = ({ selected }) => {
    setPageNumber(selected)
  }

  const [Subscribe, setSubscribe] = useState([]) // substraction details for

  const [Recharge, setRecharge] = useState([])
  const [referral, setReferral] = useState([])

  const [listPerPage3] = useState(5)
  const [pageNumber3, setPageNumber3] = useState(0)

  const pagesVisited3 = pageNumber3 * listPerPage3
  const lists3 = Recharge.slice(pagesVisited3, pagesVisited3 + listPerPage3)
  const pageCount3 = Math.ceil(Recharge.length / listPerPage3)
  const changePage3 = ({ selected3 }) => {
    setPageNumber3(selected3)
  }

  const [CompletedListing, setCompletedListing] = useState([])

  const [listPerPage1] = useState(5)
  const [pageNumber1, setPageNumber1] = useState(0)

  const pagesVisited1 = pageNumber1 * listPerPage1
  const lists1 = CompletedListing.slice(
    pagesVisited1,
    pagesVisited1 + listPerPage1
  )
  const pageCount1 = Math.ceil(CompletedListing.length / listPerPage1)
  const changePage1 = ({ selected }) => {
    setPageNumber1(selected)
  }

  const [Posts, setPosts] = useState([])

  const [listPerPage2] = useState(5)
  const [pageNumber2, setPageNumber2] = useState(0)

  const pagesVisited2 = pageNumber2 * listPerPage2
  const lists2 = Posts.slice(pagesVisited2, pagesVisited2 + listPerPage2)
  const pageCount2 = Math.ceil(Posts.length / listPerPage2)
  const changePage2 = ({ selected }) => {
    setPageNumber2(selected)
  }

  const [Posters, setPosters] = useState([])

  const [listPerPage4] = useState(5)
  const [pageNumber4, setPageNumber4] = useState(0)

  const pagesVisited4 = pageNumber4 * listPerPage4
  const lists4 = Posters.slice(pagesVisited4, pagesVisited4 + listPerPage4)
  const pageCount4 = Math.ceil(Posters.length / listPerPage4)
  const changePage4 = ({ selected4 }) => {
    setPageNumber4(selected4)
  }
  const [listPerPage10] = useState(5)
  const [pageNumber10, setPageNumber10] = useState(0)

  const pagesVisited10 = pageNumber10 * listPerPage10
  const lists10 = referral.slice(pagesVisited10, pagesVisited10 + listPerPage10)
  const pageCount10 = Math.ceil(referral.length / listPerPage10)
  const changePage10 = ({ selected10 }) => {
    setPageNumber10(selected10)
  }

  const [UserTargetCount, setUserTargetCount] = useState([])

  const [UserTargetReachCount, setUserTargetReachCount] = useState([])

  useEffect(() => {
    GetOneActins()
  }, [])

  var gets = localStorage.getItem("authUser")
  var data = JSON.parse(gets)
  var datas = data.token

  const Actinid = sessionStorage.getItem("UserId")

  const GetOneActins = () => {
    const data = {
      userId: Actinid,
    }
    var token = datas
    axios.post(URLS.GetIdUserlist, data, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(res => {
        const responseData = res.data
        const updatedSubscribe = {
          ...responseData.usersubscription,
          invoiceAddCounts: responseData.invoiceAddCounts,
          cashbookCounts: responseData.cashbookCounts,
          userCreatedbyvenbdorCounts: responseData.userCreatedbyvenbdorCounts,
          allListingsCount: responseData.allListingsCount,
          uploadCount: responseData.uploadCount,
          postersCount: responseData.postersCount,
          addProductsCount : responseData.addProductsCount,
        }
        // console.log(updatedSubscribe[0])
        setSubscribe(updatedSubscribe)
        setforms(res.data.user[0])
        setPendingListing(res.data.completedListings)
        setCompletedListing(res.data.rejectedListings)
        setPosts(res.data.userPosts)
        setPosters(res.data.usersavedtemplates)
        setRecharge(res.data?.rechargehistory)
        setUserTargetCount(res.data?.useruploadcounts[0])
        setUserTargetReachCount(res.data)
        setReferral(res.data.referredUsers)
      })
  }

  const Actinid1 = data => {
    sessionStorage.setItem("ListingId", data._id)
    history.push("/ViewUserListing")
  }

  const [modal_small, setmodal_small] = useState(false)

  const [form1, setform1] = useState([])

  const [form2, setform2] = useState([])

  function tog_small() {
    setmodal_small(!modal_small)
  }

  const getpopup = data => {
    setform2(data)
    tog_small()
  }

  const handleChange1 = e => {
    let myUser = { ...form1 }
    myUser[e.target.name] = e.target.value
    setform1(myUser)
  }

  const handleSubmit1 = e => {
    e.preventDefault()
    Editstate()
  }

  const Editstate = () => {
    var token = datas
    const dataArray = {
      status: form1.status,
      serviceId: form2._id,
    }
    axios
      .post(URLS.UpdateUserListing, dataArray, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(
        res => {
          if (res.status === 200) {
            GetOneActins()
            toast(res.data.message)
            setmodal_small(false)
            setform1({
              status: "",
            })
          }
        },
        error => {
          if (error.response && error.response.status === 400) {
            toast(error.response.data.message)
          }
        }
      )
  }

  const Actinids = data => {
    sessionStorage.setItem("RechargeId", data._id)
    history.push("/ViewService")
  }

  var gets = localStorage.getItem("authUser")
  var data = JSON.parse(gets)
  var Roles = data?.rolesAndPermission[0]

  var gets = localStorage.getItem("authUser")
  var data = JSON.parse(gets)

  const manageDelete = data => {
    const confirmBox = window.confirm("Do you really want to InActive?")
    if (confirmBox === true) {
      Delete(data)
    }
  }

  const Delete = data => {
    var token = datas
    axios
      .put(
        URLS.GetIdUserBlock,
        { userId: data._id },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(
        res => {
          if (res.status === 200) {
            toast(res.data.message)
            history.push("/BlockedUsers")
            GetOneActins()
          }
        },
        error => {
          if (error.response && error.response.status === 400) {
            toast(error.response.data.message)
          }
        }
      )
  }

  // Downlod image and videoo
  const downloadImage = url => {
    saveAs(url, url.split("/").pop())
  }

  const manageDelete1 = data => {
    const confirmBox = window.confirm("Do you really want to Active?")
    if (confirmBox === true) {
      Delete1(data)
    }
  }

  const Delete1 = data => {
    var token = datas
    axios
      .put(
        URLS.GetIdUserBlock,
        { userId: data._id },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(
        res => {
          if (res.status === 200) {
            toast(res.data.message)
            history.push("/Users")
            GetOneActins()
          }
        },
        error => {
          if (error.response && error.response.status === 400) {
            toast(error.response.data.message)
          }
        }
      )
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Home " breadcrumbItem="User Profile" />
          <Row>
            <Col>
              <Button
                onClick={() => history.goBack()}
                className="mb-3  m-1 "
                style={{ float: "right" }}
                color="primary"
              >
                <i className="far fa-arrow-alt-circle-left"></i> Back
              </Button>

              {Roles?.InActiveUsersActive == true ||
              Roles?.accessAll == true ? (
                <>
                  {forms.status == true ? (
                    <Button
                      onClick={() => {
                        manageDelete(forms)
                      }}
                      className="m-1 "
                      color="danger"
                      style={{ float: "right" }}
                    >
                      <div className="d-flex">
                        <i className="fas fa-user-lock"></i> Block
                      </div>
                    </Button>
                  ) : (
                    <Button
                      onClick={() => {
                        manageDelete1(forms)
                      }}
                      className="m-1 "
                      color="success"
                      style={{ float: "right" }}
                    >
                      <i className="fas fa-user-check"></i>
                      UnBlock
                    </Button>
                  )}{" "}
                </>
              ) : (
                ""
              )}
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Card>
                <CardBody>
                  <Row>
                    <Col md={12}>
                      <h5 className="mt-2 text-primary">Usage Count :-</h5>
                      <div className="table-rep-plugin mt-4 table-responsive">
                        <Table hover className="table table-bordered mb-4 ">
                          <thead>
                            <tr className="text-center">
                              <th>Count</th>
                              <th>Listing Count </th>
                              {/* <th>Posts Count</th> */}
                              <th>Poster's Count</th>
                              {/* <th>Poster's Count</th> */}
                              <th>Upload Count</th>
                              <th>CashBook Count</th>
                              <th>Products Count</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr className="text-center">
                              <td>Plan Count</td>
                              <td>{UserTargetCount.listingCount}</td>
                              <td>{UserTargetCount.postCount}</td>
                              <td>{UserTargetCount.uploadCount}</td>
                              {/* <td>{UserTargetCount.cashBookCount}</td> */}
                              <td>{UserTargetCount.cashBookEntriesCount}</td>
                              <td>{UserTargetCount.productsLimit}</td>
                              {/* <td>{Subscribe.planProductsCount}</td> */}
                            </tr>
                            <tr className="text-center">
                              <td>Usage Count</td>
                              <td>
                                {UserTargetReachCount.userlistingcoutnDocuments}
                              </td>
                              <td>
                                {UserTargetReachCount.userpostscountDocumsnts}
                              </td>
                              <td>
                                {
                                  UserTargetReachCount.usersavedtemplatecountDocuments
                                }
                              </td>
                              <td>
                                {UserTargetReachCount.cashbookcountdocuments}
                              </td>
                              <td>
                                {UserTargetReachCount.addProductsCount}
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row className="mb-5">
            <Col md={12}>
              <Row>
                <Col md={3}>
                  <Card>
                    <CardBody>
                      <h5 className="mt-2 text-primary">User Information :-</h5>
                      <Nav pills className="flex-column">
                        <NavItem>
                          <NavLink
                            style={{
                              border: "1px #806530 solid",
                              borderRadius: "5px",
                              padding: "8px",
                              margin: "6px",
                            }}
                            className={classnames({
                              active: activeTab1 === "5",
                            })}
                            onClick={() => {
                              toggle1("5")
                            }}
                          >
                            {" "}
                            <span className="bx bx-chevrons-right"></span>
                            Profile
                          </NavLink>
                        </NavItem>
                        {/* <NavItem>
                          <NavLink
                            style={{
                              border: "1px #806530 solid",
                              borderRadius: "5px",
                              padding: "8px",
                              margin: "6px",
                            }}
                            className={classnames({
                              active: activeTab1 === "9",
                            })}
                            onClick={() => {
                              toggle1("9")
                            }}
                          >
                            {" "}
                            <span className="bx bx-chevrons-right"></span>
                            Recharge History
                          </NavLink>
                        </NavItem> */}

                        <NavItem className="mt-2">
                          <NavLink
                            style={{
                              border: "1px #806530 solid",
                              borderRadius: "5px",
                              padding: "8px",
                              margin: "6px",
                            }}
                            className={classnames({
                              active: activeTab1 === "12",
                            })}
                            onClick={() => {
                              toggle1("12")
                            }}
                          >
                            <span className="bx bx-chevrons-right"></span>
                            Subscription Details
                          </NavLink>
                        </NavItem>

                        <NavItem>
                          <NavLink
                            style={{
                              border: "1px #806530 solid",
                              borderRadius: "5px",
                              padding: "8px",
                              margin: "6px",
                            }}
                            className={classnames({
                              active: activeTab1 === "6",
                            })}
                            onClick={() => {
                              toggle1("6")
                            }}
                          >
                            {" "}
                            <span className="bx bx-chevrons-right"></span>
                            User Listing
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            style={{
                              border: "1px #806530 solid",
                              borderRadius: "5px",
                              padding: "8px",
                              margin: "6px",
                            }}
                            className={classnames({
                              active: activeTab1 === "7",
                            })}
                            onClick={() => {
                              toggle1("7")
                            }}
                          >
                            {" "}
                            <span className="bx bx-chevrons-right"></span>
                            Rejected Listing
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            style={{
                              border: "1px #806530 solid",
                              borderRadius: "5px",
                              padding: "8px",
                              margin: "6px",
                            }}
                            className={classnames({
                              active: activeTab1 === "8",
                            })}
                            onClick={() => {
                              toggle1("8")
                            }}
                          >
                            <span className="bx bx-chevrons-right"></span>
                            Posts
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            style={{
                              border: "1px #806530 solid",
                              borderRadius: "5px",
                              padding: "8px",
                              margin: "6px",
                            }}
                            className={classnames({
                              active: activeTab1 === "10",
                            })}
                            onClick={() => {
                              toggle1("10")
                            }}
                          >
                            <span className="bx bx-chevrons-right"></span>
                            Poster's
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            style={{
                              border: "1px #806530 solid",
                              borderRadius: "5px",
                              padding: "8px",
                              margin: "6px",
                            }}
                            className={classnames({
                              active: activeTab1 === "11",
                            })}
                            onClick={() => {
                              toggle1("11")
                            }}
                          >
                            <span className="bx bx-chevrons-right"></span>
                            Referral User ({referral.length})
                          </NavLink>
                        </NavItem>
                      </Nav>
                    </CardBody>
                  </Card>
                </Col>
                <Col md={9}>
                  <Card>
                    <CardBody>
                      <TabContent
                        activeTab={activeTab1}
                        className="p-4  text-muted"
                      >
                        <TabPane tabId="5">
                          <Row>
                            <h5 className="mb-3 text-primary">Profile :-</h5>
                            <Col lg={6}>
                              <ul className="list-unstyled vstack gap-3 mb-0">
                                {forms.profilePic == "" ? (
                                  <>
                                    {" "}
                                    <img
                                      src={logo}
                                      height="100px"
                                      width="50%"
                                    ></img>
                                  </>
                                ) : (
                                  <>
                                    <img
                                      src={URLS.Base + forms.profilePic}
                                      height="150px"
                                      width="50%"
                                    ></img>
                                  </>
                                )}
                                <li>
                                  <div className="d-flex mt-3">
                                    <i className="bx bx-user font-size-18 text-primary"></i>
                                    <div className="ms-3">
                                      <h6 className="mb-1 fw-semibold">
                                        Name:
                                      </h6>
                                      <span className="text-muted">
                                        {forms.name}
                                      </span>
                                    </div>
                                  </div>
                                </li>
                                <li>
                                  <div className="d-flex  mt-3">
                                    <i className="bx bx-message-rounded font-size-18 text-primary"></i>
                                    <div className="ms-3">
                                      <h6 className="mb-1 fw-semibold">
                                        Email :
                                      </h6>
                                      {forms.email}
                                    </div>
                                  </div>
                                </li>
                                <li>
                                  <div className="d-flex  mt-3">
                                    <i className="bx bx-phone font-size-18 text-primary"></i>
                                    <div className="ms-3">
                                      <h6 className="mb-1 fw-semibold">
                                        Contact Number:
                                      </h6>
                                      {forms.phone}
                                    </div>
                                  </div>
                                </li>
                                <li>
                                  <div className="d-flex mt-3">
                                    <i className="bx bx-area font-size-18 text-primary"></i>
                                    <div className="ms-3">
                                      <h6 className="mb-1 fw-semibold">
                                        Business Type:
                                      </h6>
                                      <span className="text-muted">
                                        {" "}
                                        {forms.vendor == false ? (
                                          <>{"individual"}</>
                                        ) : (
                                          <></>
                                        )}
                                      </span>
                                    </div>
                                  </div>
                                </li>
                              </ul>
                            </Col>
                            <Col lg={6}>
                              <ul className="list-unstyled vstack gap-3 mb-0">
                                <li>
                                  <div className="d-flex mt-3">
                                    <i className="bx bx-area font-size-18 text-primary"></i>
                                    <div className="ms-3">
                                      <h6 className="mb-1 fw-semibold">
                                        Community:
                                      </h6>
                                      <span className="text-muted">
                                        {forms.community}
                                      </span>
                                    </div>
                                  </div>
                                </li>
                                <li>
                                  <div className="d-flex mt-3">
                                    <i className="bx bx-area font-size-18 text-primary"></i>
                                    <div className="ms-3">
                                      <h6 className="mb-1 fw-semibold">
                                        Address:
                                      </h6>
                                      <span className="text-muted">
                                        {forms.address}
                                      </span>
                                    </div>
                                  </div>
                                </li>
                                <li>
                                  <div className="d-flex mt-3">
                                    <i className="bx bx-area font-size-18 text-primary"></i>
                                    <div className="ms-3">
                                      <h6 className="mb-1 fw-semibold">
                                        Date Of Birth:
                                      </h6>
                                      <span className="text-muted">
                                        {forms.dateOfBirth}
                                      </span>
                                    </div>
                                  </div>
                                </li>
                                <li>
                                  <div className="d-flex mt-3">
                                    <i className="bx bx-wallet-alt font-size-18 text-primary"></i>
                                    <div className="ms-3">
                                      <h6 className="mb-1 fw-semibold">
                                        Coins:
                                      </h6>
                                      <span className="text-muted">
                                        {forms.coins == "" ||
                                        forms.coins == undefined ? (
                                          <>{"-"}</>
                                        ) : (
                                          <>{forms.coins}</>
                                        )}
                                      </span>
                                    </div>
                                  </div>
                                </li>
                                <li>
                                  <div className="d-flex  mt-3">
                                    <i className="bx bx-broadcast font-size-18 text-primary"></i>
                                    <div className="ms-3">
                                      <h6 className="mb-1 fw-semibold">
                                        Status :
                                      </h6>
                                      <span className="badge bg-success">
                                        {forms.vendor == false ? (
                                          <>{"Active"}</>
                                        ) : (
                                          <>{"InActive"}</>
                                        )}
                                      </span>
                                    </div>
                                  </div>
                                </li>
                                <li>
                                  <div className="d-flex mt-3">
                                    <i className="bx bx-area font-size-18 text-primary"></i>
                                    <div className="ms-3">
                                      <h6 className="mb-1 fw-semibold">
                                        Anniversery:
                                      </h6>
                                      <span className="text-muted">
                                        {forms.anniversery}
                                      </span>
                                    </div>
                                  </div>
                                </li>
                              </ul>
                            </Col>
                          </Row>
                        </TabPane>

                        {/* Subscription details */}

                        <TabPane tabId="12">
                          <h5 className="mt-2 text-primary">
                            Plan Information :-
                          </h5>
                          <div className="table-rep-plugin mt-4 table-responsive">
                            <Table hover className="table table-bordered mb-4 ">
                              <thead>
                                <tr className="text-center">
                                  <th>Purchase Date </th>
                                  <th>Expired Date </th>
                                  {/* <th>Plan Amount</th> */}
                                  <th>Offer Price</th>
                                  <th>Payment status </th>
                                  <th>Transtation Id</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr className="text-center">
                                  <td>
                                    {" "}
                                    <span className="badge bg-danger">
                                      {Subscribe?.planPurchaseDate?.slice(
                                        0,
                                        10
                                      )}
                                    </span>
                                  </td>
                                  <td>
                                    {" "}
                                    <span className="badge bg-danger">
                                      {Subscribe?.planExpiryDate?.slice(0, 10)}
                                    </span>
                                  </td>
                                  <td>{Subscribe?.planTransactionAmount}</td>
                                  <td>{Subscribe?.planPaymentStatus}</td>
                                  <td>{Subscribe?.planTransactionId}</td>
                                </tr>
                              </tbody>
                            </Table>
                          </div>
                          <Row className="mt-2">
                            <h5 className="mt-2 text-primary">
                              Plan Details :-
                            </h5>
                            <Col md={12}>
                              <div className="table-rep-plugin mt-4 table-responsive">
                                <Table
                                  hover
                                  className="table table-bordered mb-4 "
                                >
                                  <thead>
                                    <tr className="text-center">
                                      <th>Plan Name</th>
                                      <td>{Subscribe?.planName}</td>
                                    </tr>
                                    <tr className="text-center">
                                      <th>Plan Validity</th>
                                      {/* <td>{Subscribe?.planValidity} Month</td> */}
                                      <td>
                                        {Subscribe?.planValidity
                                          ? `${Subscribe.planValidity} ${
                                              Subscribe.planValidity > 1
                                                ? "Months"
                                                : "Month"
                                            }`
                                          : null}
                                      </td>
                                    </tr>
                                    <tr className="text-center">
                                      <th>Plan Price</th>
                                      <td>{Subscribe?.planPrice}</td>
                                    </tr>
                                    <tr className="text-center">
                                      <th>Poster's Count </th>
                                      <td>{Subscribe?.planPostCount}</td>
                                    </tr>
                                    <tr className="text-center">
                                      <th>Listing Count</th>
                                      <td>{Subscribe?.planListingCount}</td>
                                    </tr>
                                    {/* <tr className="text-center">
                                      <th>Cutsomer Add Count</th>
                                      <td>{Subscribe?.planCutsomerAddCount}</td>
                                    </tr> */}
                                    {/* <tr className="text-center">
                                      <th>Invoice Add Count</th>
                                      <td>{Subscribe?.planInvoiceAddCount}</td>
                                    </tr> */}
                                    <tr className="text-center">
                                      <th>CashBook Entries Count</th>
                                      <td>
                                        {Subscribe?.planCashBookEntriesCount}
                                      </td>
                                    </tr>
                                    <tr className="text-center">
                                      <th>Products Count</th>
                                      <td>
                                        {Subscribe?.planProductsCount}
                                      </td>
                                    </tr>
                                    <tr className="text-center">
                                      <th>Upload Count</th>
                                      <td>{Subscribe?.planUploadCount}</td>
                                    </tr>
                                  </thead>
                                </Table>
                              </div>
                            </Col>
                          </Row>
                        </TabPane>

                        <TabPane tabId="6">
                          <h5
                            className="modal-title mt-0"
                            id="mySmallModalLabel"
                          >
                            User Listing
                          </h5>
                          <div className="table-rep-plugin mt-4 table-responsive">
                            <Table hover className="table table-bordered mb-4 ">
                              <thead>
                                <tr className="text-center">
                                  <th>Sl.No</th>
                                  <th>Business Image</th>
                                  <th>Category Name</th>
                                  <th>Status</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {lists.map((data, key) => (
                                  <tr key={key} className="text-center">
                                    <td>{(pageNumber - 1) * 5 + key + 6}</td>
                                    <td>
                                      <img
                                        src={URLS.Base + data.serviceImg[0]}
                                        style={{ width: "50px" }}
                                      />
                                    </td>
                                    <td>{data.categoryName}</td>
                                    <td>{data.listingStatus}</td>
                                    <td>
                                      <Button
                                        onClick={() => {
                                          Actinid1(data)
                                        }}
                                        size="sm"
                                        className="m-1 btn-sm"
                                        color="info"
                                      >
                                        <div className="d-flex">
                                          <small>
                                            <i className="fas fa-eye px-1"></i>
                                            View
                                          </small>
                                        </div>
                                      </Button>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </Table>
                          </div>
                          <Col md={12}>
                            <div
                              className="d-flex mt-3 mb-1"
                              style={{ float: "right" }}
                            >
                              <ReactPaginate
                                previousLabel={"Previous"}
                                nextLabel={"Next"}
                                pageCount={pageCount}
                                onPageChange={changePage}
                                containerClassName={"pagination"}
                                previousLinkClassName={"previousBttn"}
                                nextLinkClassName={"nextBttn"}
                                disabledClassName={"disabled"}
                                activeClassName={"active"}
                                total={lists.length}
                              />
                            </div>
                          </Col>
                        </TabPane>
                        <TabPane tabId="7">
                          <h5
                            className="modal-title mt-0"
                            id="mySmallModalLabel"
                          >
                            Rejected Listing
                          </h5>
                          <div className="table-rep-plugin mt-4 table-responsive">
                            <Table hover className="table table-bordered mb-4 ">
                              <thead>
                                <tr className="text-center">
                                  <th>Sl.No</th>
                                  <th>Business Image</th>
                                  <th>Category Name</th>
                                  <th>Status</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {lists1.map((data, key) => (
                                  <tr key={key} className="text-center">
                                    <td>{(pageNumber - 1) * 5 + key + 6}</td>
                                    <td>
                                      <img
                                        src={URLS.Base + data.serviceImg[0]}
                                        style={{ width: "50px" }}
                                      />
                                    </td>
                                    <td>{data.categoryName}</td>
                                    <td>{data.listingStatus}</td>
                                    <td>
                                      <Button
                                        onClick={() => {
                                          Actinid1(data)
                                        }}
                                        size="sm"
                                        className="m-1"
                                        color="info"
                                      >
                                        <div className="d-flex">
                                          <small>
                                            <i className="fas fa-eye px-1"></i>
                                            View
                                          </small>
                                        </div>
                                      </Button>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </Table>
                          </div>
                          <Col md={12}>
                            <div
                              className="d-flex mt-3 mb-1"
                              style={{ float: "right" }}
                            >
                              <ReactPaginate
                                previousLabel={"Previous"}
                                nextLabel={"Next"}
                                pageCount={pageCount1}
                                onPageChange={changePage1}
                                containerClassName={"pagination"}
                                previousLinkClassName={"previousBttn"}
                                nextLinkClassName={"nextBttn"}
                                disabledClassName={"disabled"}
                                activeClassName={"active"}
                                total={lists1.length}
                              />
                            </div>
                          </Col>
                        </TabPane>
                        <TabPane tabId="8">
                          <Row>
                            <h5
                              className="modal-title mt-0"
                              id="mySmallModalLabel"
                            >
                              Posts
                            </h5>
                            <div className="table-rep-plugin table-responsive mt-3">
                              <Table hover bordered responsive>
                                <thead>
                                  <tr className="text-center">
                                    <th>Sl.No</th>
                                    <th>Description</th>
                                    <th>Image</th>
                                  </tr>
                                </thead>
                                <tbody className="text-center">
                                  {lists2.map((data, key) => (
                                    <tr key={key}>
                                      <td>{(pageNumber2 - 1) * 5 + key + 6}</td>
                                      <td>{data.description}</td>
                                      {/* <td>
                                        <img
                                          src={URLS.Base + data.image}
                                          height="120px"
                                        ></img>
                                      </td> */}
                                      <td>
                                        <div className="d-inline-flex align-items-center">
                                          {data.thumbnail ? (
                                            <>
                                              <video
                                                width="200px"
                                                height="200px"
                                                controls
                                                style={{ cursor: "pointer" }}
                                              >
                                                <source
                                                  src={URLS.Base + data.image}
                                                  type="video/mp4"
                                                />
                                                Your browser does not support
                                                the video tag.
                                              </video>
                                              <i
                                                className="bx bx-download"
                                                style={{
                                                  fontSize: "24px",
                                                  color: "#007bff",
                                                  marginLeft: "10px",
                                                  cursor: "pointer",
                                                }}
                                                onClick={() =>
                                                  downloadImage(
                                                    URLS.Base + data.image
                                                  )
                                                }
                                              ></i>
                                            </>
                                          ) : (
                                            <>
                                              <img
                                                src={
                                                  data.thumbnail
                                                    ? URLS.Base + data.thumbnail
                                                    : URLS.Base + data.image
                                                }
                                                alt="Media"
                                                style={{
                                                  width: "80px",
                                                  cursor: "pointer",
                                                }}
                                              />
                                              <i
                                                className="bx bx-download"
                                                style={{
                                                  fontSize: "24px",
                                                  color: "#007bff",
                                                  marginLeft: "10px",
                                                  cursor: "pointer",
                                                }}
                                                onClick={() =>
                                                  downloadImage(
                                                    data.thumbnail
                                                      ? URLS.Base +
                                                          data.thumbnail
                                                      : URLS.Base + data.image
                                                  )
                                                }
                                              ></i>
                                            </>
                                          )}
                                        </div>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </Table>
                              <Col md={12}>
                                <div
                                  className="d-flex mt-3 mb-1"
                                  style={{ float: "right" }}
                                >
                                  <ReactPaginate
                                    previousLabel={"Previous"}
                                    nextLabel={"Next"}
                                    pageCount={pageCount2}
                                    onPageChange={changePage2}
                                    containerClassName={"pagination"}
                                    previousLinkClassName={"previousBttn"}
                                    nextLinkClassName={"nextBttn"}
                                    disabledClassName={"disabled"}
                                    activeClassName={"active"}
                                    total={lists2.length}
                                  />
                                </div>
                              </Col>
                            </div>
                          </Row>
                        </TabPane>
                        <TabPane tabId="10">
                          <Row>
                            <h5
                              className="modal-title mt-0"
                              id="mySmallModalLabel"
                            >
                              Poster's
                            </h5>
                            <div className="table-rep-plugin table-responsive mt-3">
                              <Table hover bordered responsive>
                                <thead>
                                  <tr className="text-center">
                                    <th>Sl.No</th>
                                    <th>Template Name</th>
                                    <th>Template Image</th>
                                  </tr>
                                </thead>
                                <tbody className="text-center">
                                  {lists4.map((data, key) => (
                                    <tr key={key}>
                                      <td>{(pageNumber4 - 1) * 5 + key + 6}</td>
                                      <td>{data.templateName}</td>
                                      <td>
                                        <img
                                          src={URLS.Base + data.templateImage}
                                          height="120px"
                                        ></img>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </Table>
                              <Col md={12}>
                                <div
                                  className="d-flex mt-3 mb-1"
                                  style={{ float: "right" }}
                                >
                                  <ReactPaginate
                                    previousLabel={"Previous"}
                                    nextLabel={"Next"}
                                    pageCount={pageCount4}
                                    onPageChange={changePage4}
                                    containerClassName={"pagination"}
                                    previousLinkClassName={"previousBttn"}
                                    nextLinkClassName={"nextBttn"}
                                    disabledClassName={"disabled"}
                                    activeClassName={"active"}
                                    total={lists4.length}
                                  />
                                </div>
                              </Col>
                            </div>
                          </Row>
                        </TabPane>
                        <TabPane tabId="9">
                          <Col lg={12}>
                            <h5
                              className="modal-title mt-0"
                              id="mySmallModalLabel"
                            >
                              All Services
                            </h5>
                            <div className="table-rep-plugin mt-4 table-responsive  mt-3">
                              <Table
                                hover
                                className="table table-bordered mb-4 "
                              >
                                <thead>
                                  <tr className="text-center">
                                    <th>Sl.No</th>
                                    <th>Date</th>
                                    <th>Service</th>
                                    <th>Amount</th>
                                    <th>Charge</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {lists3.map((data, key) => (
                                    <tr key={key} className="text-center">
                                      <td>{(pageNumber3 - 1) * 5 + key + 6}</td>
                                      <td>
                                        {data.date} - {data.time}
                                      </td>
                                      <td>{data.category}</td>
                                      <td>{data.totalAmount}</td>
                                      <td>{data.platformFee}%</td>
                                      <td>{data.paymentStatus}</td>
                                      <td>
                                        <Button
                                          onClick={() => {
                                            Actinids(data)
                                          }}
                                          className="m-1 btn-sm"
                                          color="info"
                                        >
                                          <div className="d-flex">
                                            <small>
                                              <i className="fas fa-eye px-1"></i>
                                              View
                                            </small>
                                          </div>
                                        </Button>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </Table>
                              <div
                                className="d-flex mt-3 mb-1"
                                style={{ float: "right" }}
                              >
                                <ReactPaginate
                                  previousLabel={"Previous"}
                                  nextLabel={"Next"}
                                  pageCount={pageCount3}
                                  onPageChange={changePage3}
                                  containerClassName={"pagination"}
                                  previousLinkClassName={"previousBttn"}
                                  nextLinkClassName={"nextBttn"}
                                  disabledClassName={"disabled"}
                                  activeClassName={"active"}
                                  total={lists3.length}
                                />
                              </div>
                            </div>
                          </Col>
                        </TabPane>
                        <TabPane tabId="11">
                          <Col lg={12}>
                            <h5
                              className="modal-title mt-0"
                              id="mySmallModalLabel"
                            >
                              Referral User
                            </h5>
                            <div className="table-rep-plugin mt-4 table-responsive  mt-3">
                              <Table
                                hover
                                className="table table-bordered mb-4 "
                              >
                                <thead>
                                  <tr className="text-center">
                                    <th>Sl.No</th>
                                    <th>Date</th>
                                    <th>Name</th>
                                    <th>Phone</th>
                                    <th>Profile Pic</th>
                                    <th>Address</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {lists10.map((data, key) => (
                                    <tr key={key} className="text-center">
                                      <td>{(pageNumber3 - 1) * 5 + key + 6}</td>
                                      <td>
                                        {data?.logCreatedDate?.slice(0, 10)}
                                      </td>
                                      <td>{data.name}</td>
                                      <td>{data.phone}</td>
                                      <td>
                                        <img src={"https://api.jaininternationalnetwork.com/" + data.profilePic} style={{height:"70px", width:"70px"}} />
                                        </td>
                                      <td>{data.address}</td>
                                     
                                    </tr>
                                  ))}
                                </tbody>
                              </Table>
                              <div
                                className="d-flex mt-3 mb-1"
                                style={{ float: "right" }}
                              >
                                <ReactPaginate
                                  previousLabel={"Previous"}
                                  nextLabel={"Next"}
                                  pageCount={pageCount10}
                                  onPageChange={changePage10}
                                  containerClassName={"pagination"}
                                  previousLinkClassName={"previousBttn"}
                                  nextLinkClassName={"nextBttn"}
                                  disabledClassName={"disabled"}
                                  activeClassName={"active"}
                                  total={lists10.length}
                                />
                              </div>
                            </div>
                          </Col>
                        </TabPane>
                      </TabContent>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>
          <Modal
            size="md"
            isOpen={modal_small}
            toggle={() => {
              tog_small()
            }}
            centered
          >
            <div className="modal-header">
              <h5 className="modal-title mt-0" id="mySmallModalLabel">
                Update User Listing
              </h5>
              <button
                onClick={() => {
                  setmodal_small(false)
                }}
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <Form
                onSubmit={e => {
                  handleSubmit1(e)
                }}
              >
                <Col md={12}>
                  <div className="mb-3">
                    <Label for="basicpill-firstname-input3">
                      Status <span className="text-danger">*</span>
                    </Label>

                    <select
                      className="form-select"
                      required
                      value={form1.status}
                      name="status"
                      onChange={e => {
                        handleChange1(e)
                      }}
                    >
                      <option value=""> Select </option>
                      <option value="completed">Approved</option>
                    </select>
                  </div>
                </Col>
                <div style={{ float: "right" }}>
                  <Button
                    onClick={() => {
                      setmodal_small(false)
                    }}
                    color="danger"
                    type="button"
                  >
                    Cancel <i className="fas fa-times-circle"></i>
                  </Button>
                  <Button className="m-1" color="primary" type="submit">
                    Submit <i className="fas fa-check-circle"></i>
                  </Button>
                </div>
              </Form>
            </div>
          </Modal>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default State
